;(function ($, window) {
    'use strict'

    // setup a shared namespace, if needed
    window.GCO = window.GCO || {}

    window.GCO.smogAlerts = (function () {

        var info = document.getElementById('smog-alert-container')
        var body = document.getElementsByTagName('body')[ 0 ]

        function togglesmog (boolean) {
            // console.log(info.style.display="", "Hello")
            // console.log("firing")
            if (boolean === false) {
                // console.log("firing block")
                info.style.display = 'none'
                body.style.overflow = 'visible'
            } else {
                info.style.display = 'block'
                body.style.overflow = 'hidden'

                // console.log("firing else")
            }
        }

        /*
        * return {
        *       success: true,
        *       data:   {
        *           current:    {
        *               created_at: "2019-02-24 19:55:03"
        *               forecast: 40
        *               level: "good"
        *               rating: "Green"
        *           },
        *           forecast:   {...}
        *       }
        * }
        * */
        function getAQIData () {
            return new Promise((resolve, reject) => {
                fetch('https://smogalertsgco.com/aqi-data')
                    .then(function (response) {
                        return response.json()
                    })
                    .then(function (data) {
                        resolve(data)
                    })
                    .catch(function (error) {
                        console.warn('AQI Data Error', error)
                        reject(error)
                    })
            })
        }

        function renderHTML (data) {
            var htmlString = ''
            // console.log($("#info"), "info")
            // for (var i = 0; i < data.length; i++) {
            // switch (data.data.forecast.forecast) {
            //     case
            // }
            var sfl = data.data.forecast.level.charAt(0).toUpperCase() + data.data.forecast.level.slice(1)
            var sf = data.data.forecast.forecast
            var d = new Date(data.data.forecast.created_at).toDateString()
            // console.log(new Date(sfd).toDateString())
            var dater = d.split(" ")
            var sfd = `${dater[1]} ${dater[2]}`
            // var sfd = dater[1] + " " + dater[2]
            // console.log(dater)
            // console.log(sf, "nkb ghjbhj kjl")
            if (sf < 51) {
                document.getElementById('triangle4').style.display = 'block'
            } else if (sf < 101) {
                document.getElementById('triangle5').style.display = 'block'
            } else if (sf < 151) {
                document.getElementById('triangle6').style.display = 'block'
            } else if (sf < 201) {
                document.getElementById('triangle1').style.display = 'block'
            } else if (sf < 301) {
                document.getElementById('triangle2').style.display = 'block'
            } else if (sf < 501) {
                document.getElementById('triangle3').style.display = 'block'
            }

            document.getElementById('smog-forecast-aqi').innerHTML = sf
            document.getElementById('smog-forecast-aqi-date').innerHTML = sfd
            document.getElementById('smog-forecast-level').innerHTML = sfl

            // console.log("Cool", data)

            var scl = data.data.current.level.charAt(0).toUpperCase() + data.data.current.level.slice(1)
            var sc = data.data.current.forecast
            // console.log(sc, "It's working")
            if (sc < 51) {
                document.getElementById('triangle44').style.display = 'block'
            } else if (sc < 101) {
                document.getElementById('triangle55').style.display = 'block'
            } else if (sc < 151) {
                document.getElementById('triangle66').style.display = 'block'
            } else if (sc < 201) {
                document.getElementById('triangle11').style.display = 'block'
            } else if (sc < 301) {
                document.getElementById('triangle22').style.display = 'block'
            } else if (sc < 501) {
                document.getElementById('triangle33').style.display = 'block'
            }

            document.getElementById('smog-current-aqi').innerHTML = sc
            document.getElementById('smog-current-level').innerHTML = scl

            // console.log(sf, "warning")
            // if(sf > 149) {
            //     document.getElementById("smog-hazardous-warning").style.display = "inline-block"
            // }

            // console.log(sf, "Nice!!!!!")
            if (sf < 51) {
                document.getElementById('smog-hazardous-warning1').style.display = 'inline-block'
            } else if (sf < 101) {
                document.getElementById('smog-hazardous-warning2').style.display = 'inline-block'
            } else if (sf < 151) {
                document.getElementById('smog-hazardous-warning3').style.display = 'inline-block'
            } else if (sf < 201) {
                document.getElementById('smog-hazardous-warning4').style.display = 'inline-block'
            } else if (sf < 301) {
                document.getElementById('smog-hazardous-warning5').style.display = 'inline-block'
            } else if (sf < 501) {
                document.getElementById('smog-hazardous-warning6').style.display = 'inline-block'
            }

        }

        function setupListeners() {
            $('#smogBtn').on('click', () => togglesmog())
            $('#smog-alert-container').on('click', () => togglesmog(false))
            $('#closeSmogBtn').on('click', () => togglesmog(false))
        }

        function init () {
            setupListeners()
            getAQIData().then(function (data) {
                // console.log("AQI Data", data);
                renderHTML(data)
            })
        }

        return {
            init: init
        }
    }())

    window.addEventListener('load', GCO.smogAlerts.init)
}(jQuery, window))
